module.exports = __webpack_public_path__ + "static/image/audience-guide1.svg?1f801b39a896b12eada3a4c9b46ba34d";